module.exports = __webpack_public_path__ + "img/studio881.f2e440ab.webp";